import { render, staticRenderFns } from "./shift.vue?vue&type=template&id=520c289e&scoped=true&"
import script from "./shift.vue?vue&type=script&lang=js&"
export * from "./shift.vue?vue&type=script&lang=js&"
import style0 from "./shift.vue?vue&type=style&index=0&id=520c289e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520c289e",
  null
  
)

export default component.exports